module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_URGO.34649e1c.png";